<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Administrador de Reportería</h2>
  </div>
  <app-data-table
    tableId="datatableReporteriaAdmin"
    [serverSide]="true"
    [serverData]="getDataTableProcesos"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Modal Configurar Reportería -->
<div class="docs-DialogExample-lgHeader reporteria-config-wrapper">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-config-reporteria reporteria-config-dialog" appPreventOutsideClick>
    <div class="ms-Dialog-title">
      Configurar Reportería — {{ nombreProcesoSeleccionado }}
    </div>
    <div class="ms-Dialog-content reporteria-config-content">

      <!-- Loading -->
      <div *ngIf="cargandoConfig" class="reporteria-loading">
        <div class="ms-Spinner">
          <div class="ms-Spinner-label">Cargando configuración del proceso...</div>
        </div>
      </div>

      <ng-container *ngIf="!cargandoConfig">

        <!-- ── Origen de datos ─────────────────────────────── -->
        <div class="reporteria-section">
          <h4 class="reporteria-section-title">Origen de datos</h4>
          <div class="tipo-origen-toggle">
            <label class="tipo-origen-option" [class.tipo-origen-option--active]="tipoOrigen === 'Variables'">
              <input
                type="radio"
                name="tipoOrigen"
                value="Variables"
                [(ngModel)]="tipoOrigen"
                (change)="onTipoOrigenChange()"
              />
              <span class="tipo-origen-icon"><i class="ms-Icon ms-Icon--Variable"></i></span>
              <span>
                <span class="ms-font-m tipo-origen-label">Variables del proceso</span>
                <span class="ms-font-xs ms-fontColor-neutralSecondary tipo-origen-desc">Variables de flujo (flujo.xxx)</span>
              </span>
            </label>
            <label class="tipo-origen-option" [class.tipo-origen-option--active]="tipoOrigen === 'Vista'">
              <input
                type="radio"
                name="tipoOrigen"
                value="Vista"
                [(ngModel)]="tipoOrigen"
                (change)="onTipoOrigenChange()"
              />
              <span class="tipo-origen-icon"><i class="ms-Icon ms-Icon--Database"></i></span>
              <span>
                <span class="ms-font-m tipo-origen-label">Vista de base de datos</span>
                <span class="ms-font-xs ms-fontColor-neutralSecondary tipo-origen-desc">Datos de una vista SQL existente</span>
              </span>
            </label>
          </div>
        </div>

        <div class="reporteria-section">
          <h4 class="reporteria-section-title">Filtro de fechas en visor</h4>
          <label class="catalogo-item-label reporteria-inline-toggle">
            <input
              type="checkbox"
              class="catalogo-checkbox"
              [(ngModel)]="habilitarBusquedaFechas"
              name="habilitarBusquedaFechas"
            />
            <span class="ms-font-m">Habilitar búsqueda por fechas en el visor</span>
          </label>

          <label class="catalogo-item-label reporteria-inline-toggle">
            <input
              type="checkbox"
              class="catalogo-checkbox"
              [(ngModel)]="habilitarHistorico"
              (change)="onHabilitarHistoricoChange()"
              name="habilitarHistorico"
            />
            <span class="ms-font-m">Habilitar histórico para consultar evolución de variables</span>
          </label>

          <div class="reporteria-historico-sp" *ngIf="habilitarHistorico">
            <ng-container *ngIf="tipoOrigen === 'Variables'">
              <label class="catalogo-item-label reporteria-inline-toggle">
                <input
                  type="radio"
                  name="modoHistorico"
                  [value]="'default'"
                  [(ngModel)]="modoHistorico"
                />
                <span class="ms-font-m">Usar histórico por defecto</span>
              </label>
              <label class="catalogo-item-label reporteria-inline-toggle">
                <input
                  type="radio"
                  name="modoHistorico"
                  [value]="'sp'"
                  [(ngModel)]="modoHistorico"
                />
                <span class="ms-font-m">Usar histórico por SP</span>
              </label>
            </ng-container>
            <p class="ms-font-s ms-fontColor-neutralSecondary reporteria-hint" *ngIf="tipoOrigen === 'Vista'">
              En origen "Vista de base de datos" el histórico solo puede resolverse mediante un stored procedure configurado.
            </p>
            <button
              type="button"
              class="ms-Button"
              *ngIf="modoHistorico === 'sp'"
              (click)="abrirModalHistoricoSp()"
            >
              <span class="ms-Button-label">Configurar SP</span>
            </button>

            <div class="reporteria-historico-sp-list" *ngIf="modoHistorico === 'sp' && historialSP.length > 0">
              <div class="reporteria-historico-sp-item" *ngFor="let sp of historialSP; let i = index">
                <span class="ms-font-s">
                  <strong>{{ sp.NombreSp }}</strong> — entrada: {{ sp.VariableEntrada }} → columna: {{ sp.VariableReporte }}
                </span>
                <button
                  type="button"
                  class="ms-CommandButton-button opt-button"
                  title="Quitar configuración de SP"
                  (click)="quitarConfiguracionHistoricoSp(i)"
                >
                  <span class="ms-CommandButton-icon ms-fontColor-red">
                    <i class="ms-Icon ms-Icon--Cancel"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div class="vista-fecha-columna" *ngIf="tipoOrigen === 'Vista' && habilitarBusquedaFechas">
            <label class="ms-Label">Columna de la vista para filtrar por fecha</label>
            <input
              type="text"
              class="ms-TextField-field reporteria-input"
              [(ngModel)]="columnaFechaVista"
              name="columnaFechaVista"
              placeholder="Ejemplo: FechaCreacion"
            />
          </div>
        </div>

        <!-- ── Selector de vista (solo modo Vista) ──────────── -->
        <div class="reporteria-section" *ngIf="tipoOrigen === 'Vista'">
          <h4 class="reporteria-section-title">Vista de base de datos</h4>
          <p class="ms-font-s ms-fontColor-neutralSecondary reporteria-hint">
            Seleccione la vista cuyos registros se mostrarán en el reporte.
          </p>
          <p class="ms-font-s ms-fontColor-neutralSecondary reporteria-empty-msg"
             *ngIf="vistasDisponibles.length === 0">
            No hay vistas disponibles en la base de datos.
          </p>
          <div class="ms-Dropdown dropdown vista-dropdown" tabindex="0" *ngIf="vistasDisponibles.length > 0">
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select
              class="form-control"
              [(ngModel)]="vistaSeleccionada"
              (change)="onVistaChange()"
              name="vistaSeleccionada"
            >
              <option value="">— Seleccione una vista —</option>
              <option *ngFor="let v of vistasDisponibles" [value]="v">{{ v }}</option>
            </select>
          </div>
        </div>

        <!-- ── Catálogo de variables / columnas de vista ───── -->
        <div
          class="reporteria-section"
          *ngIf="tipoOrigen === 'Variables' || (tipoOrigen === 'Vista' && vistaSeleccionada)"
        >
          <h4 class="reporteria-section-title">
            {{ tipoOrigen === 'Vista' ? 'Columnas de ' + vistaSeleccionada : 'Variables disponibles del proceso' }}
          </h4>
          <p class="ms-font-s ms-fontColor-neutralSecondary reporteria-hint">
            Marque las {{ tipoOrigen === 'Vista' ? 'columnas' : 'variables' }} que desea mostrar en el reporte.
          </p>

          <!-- Spinner cargando columnas -->
          <div *ngIf="cargandoCatalogo" class="reporteria-loading">
            <div class="ms-Spinner">
              <div class="ms-Spinner-label">Cargando columnas...</div>
            </div>
          </div>

          <ng-container *ngIf="!cargandoCatalogo">
            <p class="ms-font-s ms-fontColor-neutralSecondary reporteria-empty-msg"
               *ngIf="catalogoVariables.length === 0">
              No se encontraron {{ tipoOrigen === 'Vista' ? 'columnas en la vista' : 'variables de flujo para este proceso' }}.
            </p>
            <div class="catalogo-list" *ngIf="catalogoVariables.length > 0">
              <div class="catalogo-item" *ngFor="let variable of catalogoVariables">
                <div class="catalogo-item-grid">
                  <label class="catalogo-item-label catalogo-item-select">
                    <input
                      type="checkbox"
                      class="catalogo-checkbox"
                      [checked]="isVariableSeleccionada(variable.NombreVariable)"
                      (change)="toggleVariable(variable, $any($event.target).checked)"
                    />
                    <span class="variable-name ms-font-m">{{ obtenerNombreLegible(variable.NombreVariable) }}</span>
                    <span class="variable-tipo ms-font-xs">{{ variable.TipoDato }}</span>
                    <span class="variable-origen ms-font-xs ms-fontColor-neutralSecondary" *ngIf="tipoOrigen === 'Variables'">
                      {{ variable.Origen }}
                    </span>
                  </label>

                  <div class="catalogo-item-options">
                    <label class="catalogo-mini-label">
                      <input
                        type="checkbox"
                        [checked]="getVisibleEnTabla(variable.NombreVariable)"
                        [disabled]="!isVariableSeleccionada(variable.NombreVariable)"
                        (change)="setVisibleEnTabla(variable.NombreVariable, $any($event.target).checked)"
                      />
                      Visible en tabla
                    </label>

                    <div class="ms-Dropdown dropdown catalogo-mini-select" tabindex="0">
                      <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
                      <select
                        class="form-control"
                        [disabled]="!isVariableSeleccionada(variable.NombreVariable)"
                        [ngModel]="getTipoControl(variable.NombreVariable)"
                        (ngModelChange)="setTipoControl(variable.NombreVariable, $event)"
                        [name]="'tipoControl_' + variable.NombreVariable"
                      >
                        <option value="input">Input</option>
                        <option value="areatext">AreaText</option>
                      </select>
                    </div>

                    <input
                      *ngIf="tipoOrigen === 'Vista' && esCampoNativoVariable(variable)"
                      type="text"
                      class="ms-TextField-field reporteria-input catalogo-ref-input"
                      [disabled]="!isVariableSeleccionada(variable.NombreVariable)"
                      [ngModel]="getColumnaReferencia(variable.NombreVariable)"
                      (ngModelChange)="setColumnaReferencia(variable.NombreVariable, $event)"
                      [name]="'ref_' + variable.NombreVariable"
                      placeholder="Columna de vista para este campo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Columnas configuradas -->
        <div class="reporteria-section" *ngIf="columnasEditando.length > 0">
          <h4 class="reporteria-section-title">
            Columnas configuradas
            <span class="ms-Badge reporteria-badge">{{ columnasEditando.length }}</span>
          </h4>
          <p class="ms-font-xs ms-fontColor-neutralSecondary reporteria-hint">
            Defina la etiqueta visible y el orden de cada columna usando las flechas.
          </p>
          <p class="ms-font-s reporteria-warning" *ngIf="hayReferenciasFaltantes()">
            <i class="ms-Icon ms-Icon--Warning"></i>
            Falta indicar la columna real de la vista para los campos nativos resaltados abajo.
          </p>
          <div class="reporteria-table-wrapper">
            <table class="ms-Table ms-Table--selectable reporteria-columnas-table">
              <thead>
                <tr>
                  <th>Variable</th>
                  <th>Etiqueta visible</th>
                  <th class="col-visible">Visible en tabla</th>
                  <th class="col-tipo">Tipo</th>
                  <th class="col-orden">Orden</th>
                  <th class="col-mover">Mover</th>
                  <th class="col-quitar">Quitar</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let col of columnasEditando; let i = index"
                  [class.reporteria-row-warning]="tipoOrigen === 'Vista' && col.EsCampoNativo && !col.ColumnaReferenciaVista?.trim()"
                >
                  <td>
                    <span class="ms-font-s variable-name-cell">{{ col.NombreVariable }}</span>
                    <span class="ms-font-xs ms-fontColor-neutralSecondary"> ({{ col.TipoDato }})</span>
                    <div class="reporteria-ref-cell" *ngIf="tipoOrigen === 'Vista' && col.EsCampoNativo">
                      <input
                        type="text"
                        class="ms-TextField-field reporteria-input catalogo-ref-input"
                        [(ngModel)]="col.ColumnaReferenciaVista"
                        [name]="'refConfigurada_' + i"
                        placeholder="Columna de vista para este campo"
                        required
                      />
                    </div>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="ms-TextField-field reporteria-input"
                      [(ngModel)]="col.Etiqueta"
                      [name]="'etiqueta_' + i"
                      maxlength="200"
                      placeholder="Etiqueta de columna"
                    />
                  </td>
                  <td class="col-visible">
                    <input type="checkbox" [(ngModel)]="col.VisibleEnTabla" [name]="'visible_' + i" />
                  </td>
                  <td class="col-tipo">
                    <div class="ms-Dropdown dropdown catalogo-mini-select" tabindex="0">
                      <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
                      <select
                        class="form-control"
                        [(ngModel)]="col.TipoControl"
                        [name]="'tipoCol_' + i"
                      >
                        <option value="input">Input</option>
                        <option value="areatext">AreaText</option>
                      </select>
                    </div>
                  </td>
                  <td class="col-orden">
                    <span class="orden-badge">{{ i + 1 }}</span>
                  </td>
                  <td class="col-mover">
                    <button
                      type="button"
                      class="ms-CommandButton-button opt-button move-btn"
                      title="Mover arriba"
                      [disabled]="i === 0"
                      (click)="moverArriba(i)"
                    >
                      <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
                        <i class="ms-Icon ms-Icon--ChevronUp"></i>
                      </span>
                    </button>
                    <button
                      type="button"
                      class="ms-CommandButton-button opt-button move-btn"
                      title="Mover abajo"
                      [disabled]="i === columnasEditando.length - 1"
                      (click)="moverAbajo(i)"
                    >
                      <span class="ms-CommandButton-icon ms-fontColor-themePrimary">
                        <i class="ms-Icon ms-Icon--ChevronDown"></i>
                      </span>
                    </button>
                  </td>
                  <td class="col-quitar">
                    <button
                      type="button"
                      class="ms-CommandButton-button opt-button"
                      title="Quitar columna"
                      (click)="quitarColumna(col)"
                    >
                      <span class="ms-CommandButton-icon ms-fontColor-red">
                        <i class="ms-Icon ms-Icon--Cancel"></i>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          *ngIf="columnasEditando.length === 0 && catalogoVariables.length > 0 && !cargandoCatalogo"
          class="reporteria-empty-msg ms-font-s ms-fontColor-neutralSecondary"
        >
          Seleccione al menos una {{ tipoOrigen === 'Vista' ? 'columna' : 'variable' }} para configurar el reporte.
        </div>

      </ng-container>
    </div>

    <!-- Acciones del dialog -->
    <div class="ms-Dialog-actions">
      <button
        type="button"
        class="ms-Button ms-Dialog-action"
        (click)="cerrarModalConfig()"
        [disabled]="botonProcesando"
      >
        <span class="ms-Button-label">Cancelar</span>
      </button>
      <button
        class="ms-Button ms-Button--primary ms-Dialog-action"
        type="button"
        (click)="guardarConfiguracion()"
        [disabled]="botonProcesando || cargandoConfig || columnasEditando.length === 0 || hayReferenciasFaltantes()"
      >
        <span class="ms-Button-label" *ngIf="!botonProcesando">Guardar configuración</span>
        <span class="ms-Button-label" *ngIf="botonProcesando">{{ textoBotonProcesando }}</span>
      </button>
    </div>
  </div>
</div>

<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-historico-sp" appPreventOutsideClick>
    <div class="ms-Dialog-title">Configuración de histórico por SP</div>
    <div class="ms-Dialog-content reporteria-config-content">
      <p class="ms-font-m">Indique el SP que resolverá la evolución del histórico y la variable de entrada asociada.</p>
      <p class="ms-font-s ms-fontColor-neutralSecondary">
        El SP debe devolver las mismas variables de salida que se ven en el reporte configurado.
      </p>

      <div class="reporteria-section">
        <label class="ms-Label is-required">Nombre del SP</label>
        <input
          type="text"
          class="ms-TextField-field reporteria-input"
          [(ngModel)]="historicoSpNombre"
          name="historicoSpNombre"
          placeholder="Ejemplo: dbo.SP_ObtenerHistorico"
        />
      </div>

      <div class="reporteria-section">
        <div class="reporteria-sp-par" *ngFor="let par of historicoSpPares; let i = index">
          <div class="reporteria-sp-par-header">
            <label class="ms-Label is-required">Variable de entrada #{{ i + 1 }}</label>
            <button
              type="button"
              class="ms-CommandButton-button opt-button"
              title="Quitar esta variable"
              *ngIf="historicoSpPares.length > 1"
              (click)="quitarParHistoricoSp(i)"
            >
              <span class="ms-CommandButton-icon ms-fontColor-red">
                <i class="ms-Icon ms-Icon--Cancel"></i>
              </span>
            </button>
          </div>
          <input
            type="text"
            class="ms-TextField-field reporteria-input"
            [(ngModel)]="par.VariableEntrada"
            [name]="'historicoSpEntrada_' + i"
            placeholder="Nombre de la variable que recibe el SP"
          />

          <label class="ms-Label is-required">Variable del reporte asociada</label>
          <select
            class="form-control"
            [(ngModel)]="par.VariableReporte"
            [name]="'historicoSpVariableReporte_' + i"
          >
            <option value="">Seleccione una variable del reporte</option>
            <option *ngFor="let col of columnasEditando" [value]="col.NombreVariable">
              {{ col.Etiqueta || col.NombreVariable }}
            </option>
          </select>
        </div>

        <button
          type="button"
          class="ms-Button reporteria-sp-add-btn"
          (click)="agregarParHistoricoSp()"
        >
          <span class="ms-Button-label">+ Agregar variable de entrada</span>
        </button>
      </div>
    </div>
    <div class="ms-Dialog-actions">
      <button class="ms-Button" type="button" (click)="cerrarModalHistoricoSp()">
        <span class="ms-Button-label">Cancelar</span>
      </button>
      <button
        class="ms-Button ms-Button--primary"
        type="button"
        (click)="agregarConfiguracionHistoricoSp()"
        [disabled]="!puedeGuardarHistoricoSp()"
      >
        <span class="ms-Button-label">Guardar SP</span>
      </button>
    </div>
  </div>
</div>

<app-modal-notify #notifyModal></app-modal-notify>
